export const AiNotePadRef = 'notes-widget';
